import script from "./DesktopInstall.vue?vue&type=script&setup=true&lang=js"
export * from "./DesktopInstall.vue?vue&type=script&setup=true&lang=js"

import "./DesktopInstall.vue?vue&type=style&index=0&id=0fc02afe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc02afe"]])

export default __exports__